import styled from 'styled-components';

const {SpearBioPlateIndex} = require('constants/dataEnum');

const BORDER_SIZE = 1;

export const SBPlateTrough = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: 1fr;
  width: 100%;
  height: 100%;
  border: ${(prop) => `${prop.borderWidth || BORDER_SIZE}px solid ${prop.borderColor || 'transparent'}`};
  background: ${(prop) => prop.background ?? ''};
  align-items: center;
  justify-items: center;

  ${(prop) =>
    prop.shadowWell
      ? `
    .labware-well-circle {
        background: none !important;
        color: none !important;
        border: none !important;
      }
    `
      : ''};
`;

export const SBPlateTroughsSectionContainer = styled.div`
  grid-area: 1 / 1 / ${(prop) => prop.gridRowEnd + 1} / ${(prop) => prop.gridColumnEnd + 1};
  display: grid;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 3px;
  gap: 2%;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: 1fr 0.5fr repeat(3, 1fr);

  .well-wrapper {
    margin: 0;
    height: 20%;
  }
`;

export const SBPlateWellsSectionContainer = styled.div`
  grid-area: ${(prop) => prop.gridRowStart + 1} / 1 / ${(prop) => prop.gridRowEnd + 1} /
    ${(prop) => prop.gridColumnEnd + 1};
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(${(prop) => prop.gridRowEnd - prop.gridRowStart}, 1fr);
  position: relative;
  width: 100%;
  height: 100%;

  .labware-well-container {
    background: none !important;
    height: 100% !important;
    width: 100% !important;
  }
`;

export const SBTroughContainer = styled.div`
  display: grid;
  border: 1px solid grey;
  align-items: center;
  justify-items: center;
  grid-template-rows: repeat(${(prop) => prop.row || 1}, 1fr);

  .labware-well-container {
    background: none !important;
    height: 76% !important;
    width: 60% !important;
  }
`;

export const SpearBioPlate = [
  [
    {
      wellSection: [
        {
          type: 'trough',
          index: SpearBioPlateIndex.INDEX_0,
        },
        {
          type: 'divider',
          subType: 'well-divider-plain',
        },
        {
          type: 'trough',
          index: SpearBioPlateIndex.INDEX_1,
        },
      ],
    },
    {
      wellSection: [
        {
          type: 'trough',
          index: SpearBioPlateIndex.INDEX_2,
        },
      ],
    },
    // remain rows in of mixedType
    {
      wellSection: [
        {
          type: 'mixWell',
          index: SpearBioPlateIndex.INDEX_3,
        },
        {
          type: 'mixWell',
          index: SpearBioPlateIndex.INDEX_4,
        },
      ],
    },
    {
      wellSection: [
        {
          type: 'mixWell',
          index: SpearBioPlateIndex.INDEX_5,
        },
        {
          type: 'mixWell',
          index: SpearBioPlateIndex.INDEX_6,
        },
      ],
    },
    {
      wellSection: [
        {
          type: 'mixWell',
          index: SpearBioPlateIndex.INDEX_7,
        },
        {
          type: 'mixWell',
          index: SpearBioPlateIndex.INDEX_8,
        },
      ],
    },
  ],
  [
    // bottom normal row section
    {
      wellSection: [
        {type: 'well', index: SpearBioPlateIndex.INDEX_9, style: {gridArea: 'middle'}},
        {type: 'well', index: SpearBioPlateIndex.INDEX_10, style: {gridArea: 'middle'}},
        {type: 'well', index: SpearBioPlateIndex.INDEX_11, style: {gridArea: 'middle'}},
      ],
    },
  ],
];
